// uses styleguide/modal.less
import PropTypes from 'prop-types';

import React, { useEffect } from 'react';
import Icon from './Icon';

const bodyClassNameOverlaid = 'sg-modal-overlaid';

function areEqual(prevProps, nextProps) {
    if (prevProps.className === nextProps.className && prevProps.children === nextProps.children) {
        return true;
    }

    return false;
}

const Modal = React.memo(({ className, closeHandler, hideCloseButton, closeBtnClassName, children }) => {
    const handleClose = () => closeHandler();
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            closeHandler();
        }
    };

    useEffect(() => {
        document.body.classList.add(bodyClassNameOverlaid);

        return () => document.body.classList.remove(bodyClassNameOverlaid);
    }, []);

    return (
        <div className="sg-modal-overlay" onClick={handleOverlayClick}>
            <div className={`sg-modal-content ${className}`}>
                {!hideCloseButton && (
                    <button type="button" className={`sg-modal-close ${closeBtnClassName}`} onClick={handleClose}>
                        <Icon alias="close" />
                    </button>
                )}
                {children}
            </div>
        </div>
    );
}, areEqual);

Modal.propTypes = {
    className: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    closeHandler: PropTypes.func.isRequired,
    hideCloseButton: PropTypes.bool,
    closeBtnClassName: PropTypes.string,
};
Modal.displayName = 'Modal';

export default Modal;
